<template>
	<section v-if="getMessages">


		<!--todas redes sociais  barra superior hidden-->
		<div class='barra-superior direita'>
			<div class="rede-social esquerda hover-change-color text-center active">
				<img src="/imgs/icons/message.svg" class="icon-size">
				<p class="m-1">Chat</p>
				<span :class="[getTotalChatQueue > 0 ? 'alert-message-out': 'alert-message-in']">
					<span :class="[getTotalChatQueue > 0 ? 'alert-message': 'alert-message-fine']"
					>{{ getTotalChatQueue }}</span>
				</span>
			</div>

			<div class="text-center createNewContact"> 
				<button v-if="getCurrentConversaIndex || getCurrentConversaIndex === 0" @click="checando" class="botao-novo-contato" title="Salvar Contato">
          			<i class="fas fa-user-plus"></i>
		  		</button>
				<template v-else>&nbsp;</template>
			</div>
		</div>
		<div class="body">
			<div :class='contatosRapido'>
				<TodasMenssagensChat class="todasMensagens"></TodasMenssagensChat>
				<component v-bind:is="contatosRapido" v-on:closeContacts="fecharContatos"></component>
			</div>
			<chat-mensagem class="chatMensagem"></chat-mensagem>
		</div>

		
		<!--fim barra superior-->
	</section>
</template>

<script>
	import {mapGetters} from 'vuex';
	import ChatMensagem from "../mensagem/ChatMensagem";
	import TodasMenssagensChat from "../mensagem/TodasMenssagensChat";
	import ContatosRapido from "../contacts/ContatosRapido.vue"
	
	export default {
		components: {ChatMensagem, TodasMenssagensChat, ContatosRapido},
		data(){
			return{
				contatosRapido: ''
			}
		},
		computed:{
			...mapGetters(
				[
					'getMessages',
					'getTotalChatQueue',
					'getTotalNaoLidoWhatsapp',
					'getTotalNaoLidoFacebook',
					'getTotalNaoLidoInstagram',
					'getCurrentConversaIndex',
					'getConversasChat'
				]
			)
		},
		methods:{
			checando(){
				console.log(this.getCurrentConversaIndex)
				console.log('dados', this.getConversasChat[this.getCurrentConversaIndex]);
				this.contatosRapido = 'contatos-rapido'
			},
			fecharContatos(){
				console.log('chegnado aqui/???')
				this.contatosRapido = '';
			}
		}
	}
</script>

<style>
.alert-message-out{
	border-bottom: solid 1px #1c869a;
	border-left: solid 1px #1c869a;
	padding: 0 0 3px 3px;
}
.alert-message{
	border: solid 1px #1c869a;
	padding: 0 5px 0 5px;
	font-size: 13px;
}
.alert-message-in{
	border-bottom: solid 1px gray;
	border-left: solid 1px gray;
	padding: 0 0 3px 3px;
}
.alert-message-fine{
	border: solid 1px gray;
	padding: 0 5px 0 5px;
	font-size: 13px;
}
.icon-size {
	width: 18px;
	height: 18px;
}
</style>


<style scoped>
	.body {
		/* height: calc(100vh - 10.5em);  */
		display: flex;
		align-items: stretch;
	}
	.todasMensagens {
		width: 18em;
		overflow-y: auto;
		background: white;
		/* border-right: 1px solid gray; */
		border-right: solid 2px #1C869A;
		border-bottom: solid 2px #1C869A;
		border-radius: 0% 2% 2% 0%;
		max-height: 63vh;

	}
	.chatMensagem {
		flex: 1;
		max-height: 75vh;
		min-height: 75vh;
	}
	
	@media screen and (max-width: 1489px) {
		.todasMensagens {
			width: 290px;
		}
        .body{
            height: calc(100vh - 14.3em);
        }

	}
    @media screen and (max-width: 941px){
        .body{
            height: calc(100vh - 19.1em);
        }
    }
	.barra-superior, .contatos-rapido{
		display: flex;
		justify-content: space-between;
	}
    /*
	@media screen and (max-height: 760px) {

        .body{
            height: calc(100vh - 18.5em);
            background-color: red;
        }
    }
    */


	.createNewContact{
		margin-top: 0.25em;
		margin-right: 0.25em;
	}

	.botao-novo-contato{
		border:none;
		background:none;
	}
</style>
